export default {
    ROULETTE_BETTING_NOW: "/api/v1.0.0/betting",
    FETCH_ROULETTE_DRAWING_RESULT: "/api/v1.0.0/drawing/roulette",
    FETCH_ROULETTE_STATISTIC: "/api/v1.0.0/drawing/roulette-statistic",
    FETCH_ROULETTE_RECENT_BET_REPORT: "/api/v1.0.0/reports/recent-betting",
    ROULETTE_FETCH_RECENT_DRAW: "/api/v1.0.0/drawing/roulette-recent-draw?size=3",
    FETCH_ROULETTE_RESULT_REPORT: "/api/v1.0.0/drawing/roulette-lists",
    FETCH_ROULETTE_WIN_LOSS_REPORT: "/api/v1.0.0/reports/win-lose",
};
